import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { SessionService } from "@services/session.service";
import { environment } from "@env/environment";
import { ApiService } from "@services/api.service";
import { take } from "rxjs/operators";
import Funcionalidades from "@shared/enums/funcionalidades.enum";
import { StateService } from "@services/state.service";
import { ErrorService } from "@services/error.service";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "@components/auth/auth.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  @Output() toggle = new EventEmitter<void>();
  private fontSizeLevel: 0 | 1 | 2;
  dropdownVisible = false;
  hasFunctionality: Function; // Funcion que sera llamada desde el component html para validar si tiene permisos para ver la funcionalidad
  nameFunctionality: Function; // Funcion que sera llamada desde el component html para mostrar el nombre de la funcionalidad
  helpFunctionality: Function; // Funcion que sera llamada desde el component html para mostrar el nombre de la funcionalidad
  funcionalidadesEnum = Funcionalidades; // Variable con las funcionalidades para ser utilizada en el component html

  constructor(
    private router: Router,
    private sessionService: SessionService,
    private apiService: ApiService,
    private stateService: StateService,
    private errorService: ErrorService,
    private toastService: ToastrService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.hasFunctionality = (funcionalidad: number) =>
      this.sessionService.hasFunctionality(funcionalidad);
    this.nameFunctionality = (funcionalidad: number) => {
      return this.sessionService.getFunctionality(funcionalidad)?.nombre_fnc;
    };
    this.helpFunctionality = (funcionalidad: number) => {
      return this.sessionService.getFunctionality(funcionalidad)?.ayuda_fnc;
    };
    this.fontSizeLevel = this.stateService.getFontSize();
  }

  login(): void {
    console.log("login desde navbar");
    this.authService.loginWithClaveUnica();
    //this.claveUnicaService.initiateLogin();
  }

  logout(event?: Event): void {
    if(!environment.production){
      this.authService.logout();
      return;
    }
    event?.preventDefault();
    const sesion = this.sessionService.getSesionActual();
      
    this.sessionService.sesion$.pipe(take(1)).subscribe((sesion) => {
      const id = sesion?.id_sesion || "";

      if (id) {
        this.apiService
          .privatePostObservable<any>(
            environment.backendUrl + environment.logout,
            { id: id }
          )
          .subscribe({
            next: (response) => {
              if (
                typeof response === "string" &&
                ["Sesión cerrada y traspasada correctamente a históricos", "Sesión no existe o ya se cerró"].includes(response.trim())
              ) {
                this.authService.logout();
              } else throw new Error("Error inesperado con la respuesta de la API logout");
            },
            error: (err) => {
              this.errorService.handle(err, "Error al cerrar sesión.");
            },
          });
      } else {
        this.toastService.error("No se encontró una sesión activa para cerrar.");
      }
    });
  }

  toggleDropdown(): void {
    this.dropdownVisible = !this.dropdownVisible;
  }

  isAuthenticated(): boolean {
    return !!this.sessionService.getSesionActual();
  }

  get userName(): string {
    return this.sessionService.getSesionActual().getNombreCompleto();
  }

  toggleContrast(event: Event): void {
    event.preventDefault();
    const htmlElement = document.documentElement;
    this.stateService.setContraste(!htmlElement.classList.contains("a11y-contrast"));
  }

  increaseFontSize(event: Event): void {
    event.preventDefault();
    if (this.fontSizeLevel < 2) this.stateService.setFontSize(++this.fontSizeLevel as 0 | 1 | 2);
  }

  decreaseFontSize(event: Event): void {
    event.preventDefault();
    if (this.fontSizeLevel > 0) this.stateService.setFontSize(--this.fontSizeLevel as 0 | 1 | 2);
  }

  getDecreaseIcon(): string {
    return this.fontSizeLevel === 0
      ? "/assets/icons/header/boton_reducir_disabled.svg"
      : "/assets/icons/header/boton_reducir.svg";
  }

  getIncreaseIcon(): string {
    return this.fontSizeLevel === 2
      ? "/assets/icons/header/boton_aumentar_disabled.svg"
      : "/assets/icons/header/boton_aumentar.svg";
  }

  isDecreaseDisabled(): boolean {
    return this.fontSizeLevel === 0;
  }

  isIncreaseDisabled(): boolean {
    return this.fontSizeLevel === 2;
  }

  toggleSidebar(): void {
    this.toggle.emit();
  }
}
